import { tassign } from 'tassign';
import {
  MENU_WANT_PROTECTED_ROUTE, MENU_SHOW_NAV_SEARCH } from './actions';

export interface IMenuState {
  wantProtectedRoute: string;
  showNavSearch: boolean;
}

export const MENU_INITIAL_STATE: IMenuState = {
  wantProtectedRoute: null,
  showNavSearch: false
};

export function menuReducer(state: IMenuState = MENU_INITIAL_STATE, action): IMenuState {
  switch (action.type) {
    case MENU_WANT_PROTECTED_ROUTE: return setWantProtectedRoute(state, action);
    case MENU_SHOW_NAV_SEARCH: return showNavSearch(state, action);
    default:
      console.error('Unknown action type in menuReducer', action.type);
  }

  return state;
}

// -------------------------------------------------------------------------------------------------

function setWantProtectedRoute(state, {type: type, route: route}): IMenuState {
  return tassign(state, {
    wantProtectedRoute: route
  });
}

function showNavSearch(state, {type: type, payload: {show: showNavMenu}}) {
  return tassign(state, {
   showNavSearch: showNavMenu
  });
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/menu/store/store.ts